/**
 * 학교 분류(schools.type) 상수
 *
 * 학교 조회 탭 분류의 기준이 되는 값. DB 의 schools.type 문자열과 1:1 대응한다.
 * 백엔드 일괄 세팅 스크립트(Argame3-admin/scripts/set-school-type.ts)와
 * 반드시 같은 문자열을 사용해야 한다.
 */

// 학교 상세 "분류" 드롭다운에 노출할 값.
// ⚠️ 백엔드가 이 문자열로 exact-match 쿼리를 하므로(교사 연수/무료 체험/학교 체험 등)
// DB에 실제 저장된 표기만 노출한다 — 새 표기(유료/무료/연수)로의 교체는
// DB 819건 마이그레이션 + 백엔드 쿼리 정합이 선행돼야 해서 보류 (B안).
// 유료 학교의 빈 분류는 저장값 변경 없이 화면에서만 "유료"로 표시한다.
export const SCHOOL_TYPE_OPTIONS = [
  "AI미래교육연구회",
  "서포터즈",
  "박람회",
  "교사 연수",
  "무료 체험",
  "학교 체험 (수기 입력)",
];

/**
 * 분류 탭 → 매칭되는 type 값 목록.
 * 여기에 매칭되는 학교는 schoolLevel(유료/체험)과 무관하게 해당 탭으로 분류된다.
 * 과거에 수기 입력된 표기 변형까지 함께 받아준다.
 */
export const SPECIAL_TYPE_MAP = {
  training: ["교사 연수", "교사연수", "연수"],
  supporters: ["서포터즈", "알공 엠버서더"],
  ai: ["AI미래교육연구회", "AI 미래교육연구회"],
  expo: ["박람회"],
};

// 특수 분류에 속하는 모든 type 값 (유료/무료 탭에서 제외하는 데 사용)
export const SPECIAL_TYPES = Object.values(SPECIAL_TYPE_MAP).flat();

/** 해당 학교가 특수 분류(연수/서포터즈/AI/박람회)에 속하는지 */
export const isSpecialType = (type) => SPECIAL_TYPES.includes((type ?? "").trim());

/** 학교 1건이 속할 탭 키를 반환한다. */
export const resolveCategory = (school) => {
  const type = (school?.type ?? "").trim();
  for (const [key, types] of Object.entries(SPECIAL_TYPE_MAP)) {
    if (types.includes(type)) return key;
  }
  return school?.schoolLevel === "guest" ? "free" : "paid";
};

// 학교 등록(계정 발급)/학교 상세 수정 화면의 "교육청" 드롭다운 선택지.
// 두 화면이 서로 다른 목록을 갖지 않도록 여기 하나로 모아 공유한다.
export const OFFICE_OPTIONS = [
  "강원도교육청",
  "경기도교육청",
  "경상남도교육청",
  "경상북도교육청",
  "광주광역시교육청",
  "대구광역시교육청",
  "대전광역시교육청",
  "베트남교육청",
  "부산광역시교육청",
  "서울특별시교육청",
  "세종특별자치시교육청",
  "울산광역시교육청",
  "인천광역시교육청",
  "전라남도교육청",
  "전라북도교육청",
  "제주특별자치도교육청",
  "충청남도교육청",
  "충청북도교육청",
];
